export const formatCompactNumber = (value: number): string => {
  if (value < 1000) return String(value);
  if (value < 1_000_000) {
    const result = value / 1000;
    return `${parseFloat(result.toFixed(2))}k`;
  }
  if (value < 1_000_000_000) {
    const result = value / 1_000_000;
    return `${parseFloat(result.toFixed(2))}M`;
  }
  const result = value / 1_000_000_000;
  return `${parseFloat(result.toFixed(2))}B`;
};
